/**
 * Response module catalog — owner review SoT after extract.
 * Product target: Command River (fused Board DNA + Mission Room), not twin dashboards.
 * Map = spatial dispatch entry; Cameras = Live lenses; Response = human+AI command river.
 */
export const PRIMARY_TABS = [
  { id: "board", label: "Queue", say: "Jobs · stages", glyph: "Q" },
  { id: "cases", label: "Case file", say: "One · proof", glyph: "C" },
];

export const CONTEXT_TOOLS = [
  { id: "assign", label: "Assign unit", icon: "plus" },
  { id: "roster", label: "People", icon: "user" },
  { id: "cell", label: "Incident cell", icon: "radio" },
];

/** Hash routes still mount extracted modules for review. */
export const RESPONSE_ROUTES = [
  "board", "assign", "roster", "cell", "cases", "robots",
];

export const TAB_RESIDUAL = {
  board: "page181-board",
  assign: "page182-assign",
  roster: "page183-roster",
  cell: "page186-cell",
  cases: "page187-cases",
  robots: "page192-robots",
};

export const OWNER_LINKS = [
  { label: "Map", path: "/ops" },
  { label: "Cameras", path: "/cameras/live" },
  { label: "Prepare", path: "/prepare/readiness" },
  { label: "Resources", path: "/dispatch/people" },
  { label: "Automations", path: "/automations" },
];

/** level 2=durable · 3=tool dialog · 4=legacy hash for owner triage */
export const MODULE_CATALOG = [
  { id: "board", level: 2, label: "Board / River queue", route: "/response/board", file: "response-board.js", suggestedHome: "response-river", status: "extracted" },
  { id: "cases", level: 2, label: "Mission Room / Focus", route: "/response/cases", file: "response-legacy-panes.js", suggestedHome: "response-river", status: "extracted" },
  { id: "assign", level: 3, label: "Assign", route: "/response/assign", file: "response-assign.js", suggestedHome: "response-dock", status: "extracted" },
  { id: "roster", level: 3, label: "People", route: "/response/roster", file: "response-roster.js", suggestedHome: "resources", status: "extracted" },
  { id: "cell", level: 3, label: "Incident cell", route: "/response/cell", file: "response-legacy-panes.js", suggestedHome: "response-dock", status: "extracted" },
  { id: "rules", level: 4, label: "Compat Rules (Live)", route: "/automations/legacy-rules", file: "response-rules.js", suggestedHome: "automations", status: "rehomed" },
  { id: "automations", level: 4, label: "Automations (canonical primary)", route: "/automations", file: "automations-primary.js", suggestedHome: "automations", status: "redirected" },
  { id: "drill", level: 4, label: "Drill (Prepare Live)", route: "/prepare/drill", file: "prepare-desk.js", suggestedHome: "prepare", status: "redirected" },
  { id: "readiness", level: 4, label: "Readiness (Prepare Live)", route: "/prepare/readiness", file: "prepare-desk.js", suggestedHome: "prepare", status: "redirected" },
  { id: "sop", level: 4, label: "Playbook (Prepare Live)", route: "/prepare/playbook", file: "prepare-desk.js", suggestedHome: "prepare", status: "redirected" },
  { id: "equipment", level: 4, label: "Equipment (Resources Live)", route: "/ops/resources?type=equipment", file: "route-mask.js", suggestedHome: "resources", status: "redirected" },
  { id: "robots", level: 4, label: "Robots", route: "/response/robots", file: "response-legacy-panes.js", suggestedHome: "resources", status: "extracted" },
];
